<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="Apply Attendance">
      <a @click="$router.back()">
        <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back </v-btn>
        <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </a>
      <v-card-component>
        <v-row>
          <v-col cols="12" md="3">
            <v-autocomplete class="mt-3" label="Request Type *" v-model="formData.requestType" :items="requestTypes" key="id" item-value="id" item-text="value"> </v-autocomplete>
          </v-col>
          <v-col cols="12" md="3">
            <v-autocomplete class="mt-3" label="Reason *" v-model="formData.reason" :items="reasons" key="id" item-value="id" item-text="value"> </v-autocomplete>
          </v-col>
          <v-col cols="12" md="3">
            <label class="font-weight-medium body-2">
              From Date *
            </label>
            <custom-date-picker @input="fromDateChange()" v-model="formData.fromDate" />
          </v-col>
          <v-col cols="12" md="3">
            <label class="font-weight-medium body-2">
              To Date *
            </label>
            <custom-date-picker v-model="formData.toDate" :minToDate="formData.fromDate" />
          </v-col>
          <!--Time Picker -->
          <v-col cols="12" md="3">
            <v-dialog color="accent" ref="dialog" v-model="modal2" :return-value.sync="formData.clockIn" persistent width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field color="accent" v-model="formData.clockIn" label="Clock In *" prepend-icon="mdi-clock-time-four-outline" readonly v-bind="attrs" v-on="on"> </v-text-field>
              </template>
              <v-time-picker color="accent" v-if="modal2" v-model="formData.clockIn" full-width>
                <v-spacer></v-spacer>
                <v-btn text color="accent" @click="modal2 = false">
                  Cancel
                </v-btn>
                <v-btn text color="accent" @click="$refs.dialog.save(formData.clockIn)">
                  OK
                </v-btn>
              </v-time-picker>
            </v-dialog>
          </v-col>
          <!--Time Picker end -->
          <!--Time Picker -->
          <v-col cols="12" md="3">
            <v-dialog color="accent" ref="dialog2" v-model="modal1" :return-value.sync="formData.clockOut" persistent width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field color="accent" v-model="formData.clockOut" label="Clock Out *" prepend-icon="mdi-clock-time-four-outline" readonly v-bind="attrs" v-on="on"> </v-text-field>
              </template>
              <v-time-picker :min="formData.clockIn" color="accent" v-if="modal1" v-model="formData.clockOut" full-width>
                <v-spacer></v-spacer>
                <v-btn text color="accent" @click="modal1 = false">
                  Cancel
                </v-btn>
                <v-btn text color="accent" @click="$refs.dialog2.save(formData.clockOut)">
                  OK
                </v-btn>
              </v-time-picker>
            </v-dialog>
          </v-col>
          <!--Time Picker end -->
          <v-col cols="12" md="3">
            <v-autocomplete label="Break Time *" v-model="formData.breakTime" :items="breakTimeOptions" key="id" item-value="id" item-text="value"> </v-autocomplete>
          </v-col>
        </v-row>

        <v-textarea outlined color="accent" name="input-7-4" label="Message *" v-model="formData.message"> </v-textarea>
        <!--File Attachments upload section start accept=".pdf,.doc,.docx,.png,.jpeg,.jpg,.ppt,.pptx"-->
        <h3>Attachments</h3>
        <b-field class="file is-primary">
          <b-upload  id="upload-zone" v-model="formData.fileAttachments" multiple class="file-label" @input="onFilechange()">
            <span class="file-cta">
              <b-icon class="file-icon" icon="upload"></b-icon>
              <span class="file-label">Click to upload</span>
            </span>
          </b-upload>
        </b-field>

        <v-row>
          <v-col v-for="(path, index) in formData.fileAttachments" :key="index" class="text-truncate relative" cols="2" md="2">
            <a>
              <v-icon>mdi-file-document-multiple-outline</v-icon>
              <span>{{ path.name }}</span>
            </a>
            <v-icon class="close-icon" @click="deleteFromFileBuffer(index)">
              mdi-close-box-outline
            </v-icon>
          </v-col>
        </v-row>
        <!--File attachment section ended -->
        <v-col>
          <div class="text-right">
            <a @click="$router.push({ name: 'staffAttendanceHome' })">
              <v-btn class="px-2 ml-1 ma-1" min-width="0">
                Cancel
              </v-btn>
            </a>
            <v-btn color="success" @click="applyAttendance()" class="px-2 ml-1 ma-1" min-width="0">
              <span class="ml-1">submit</span>
            </v-btn>
          </div>
        </v-col>
      </v-card-component>
    </material-card>
  </v-container>
</template>

<script>
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'
import constants from '@/utils/constants'
import { mapGetters } from 'vuex'
import CustomDatePicker from '@/components/template/CustomDatePicker'
import moment from 'moment'

export default {
  name: 'applyAttendance',
  components: { VCardComponent, MaterialCard, CustomDatePicker },
  async created () {
    for (let i = 0; i < 121; i++) {
      this.breakTimeOptions.push({
        id: i,
        value: `${i} min`
      })
    }
  },
  beforeDestroy () {
    let elements = document.getElementsByClassName('vuedl-layout__closeBtn')
    if (elements.length > 0) {
      elements[0].click()
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    franchisee: async function (val) {
      console.log(val.id)
    },
    academicYear: async function (val) {
      console.log(val.id)
    }
  },
  data () {
    return {
      modal1: false,
      modal2: false,
      menu2: false,
      formData: {
        requestType: 'Attendance',
        reason: 'Work From Home',
        fromDate: moment().format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
        clockIn: '09:00',
        clockOut: '18:00',
        breakTime: 0,
        message: '',
        fileAttachments: []
      },
      breakTimeOptions: [],
      allowedFiles: ['pdf', 'pptx', 'docx', 'jpg', 'jpeg', 'png'],
      requestTypes: [
        {
          id: 'Attendance',
          value: 'Attendance'
        }
      ],
      reasons: [
        {
          id: 'Work From Home',
          value: 'Work From Home'
        }
      ]
    }
  },
  methods: {
    async applyAttendance () {
      try {
        if (!this.franchisee.id) {
          return this.errMsg('Please select franchisee from the sidebar!')
        }
        if (!this.academicYear.id) {
          return this.errMsg('Please select academicYear from the sidebar!')
        }
        if (!this.formData.message) {
          return this.errMsg('Please type a message to apply attendance!')
        }
        let formData = new FormData()
        console.log(this.formData)
        for (let i = 0; i < this.formData.fileAttachments.length; i++) {
          formData.append('attachment', this.formData.fileAttachments[i])
        }
        formData.append('academicYearID', this.academicYear.id)
        formData.append('franchiseeID', this.franchisee.id)
        formData.append('fromDate', this.formData.fromDate)
        formData.append('toDate', this.formData.toDate)
        formData.append('type', this.formData.requestType)
        formData.append('reason', this.formData.reason)
        formData.append('clockInTime', this.formData.clockIn)
        formData.append('clockOutTime', this.formData.clockOut)
        formData.append('breakDuration', this.timeConvert(this.formData.breakTime))
        formData.append('message', this.formData.message)
        let res = await http.post(`${constants.API_URL}/api/attendanceModule/applyattendanceleave`, formData)
        // Redirecting the user back to the list view after success response
        this.$buefy.dialog.confirm({
          type: 'is-success',
          title: 'Success',
          hasIcon: true,
          message: res.data,
          onConfirm: () => this.$router.push({ name: 'teacherAttendance' }),
          canCancel: ['x']
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error in fetching data : ', errorMessage)
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          title: 'Failed to apply attendance',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    timeConvert (min) {
      let hours = Math.floor(min / 60)
      let minutes = min % 60
      hours = hours.toString()
      minutes = minutes.toString()
      hours = `${hours.length > 1 ? hours : '0' + hours}`
      minutes = `${minutes.length > 1 ? minutes : '0' + minutes}`
      return hours + ':' + minutes
    },
    fromDateChange () {
      if (moment(this.formData.fromDate).isAfter(this.formData.toDate)) {
        this.formData.toDate = this.formData.fromDate
      }
    },
    onFilechange () {
      let errFormat = ''
      let r = this.formData.fileAttachments.filter((a, i) => {
        let result = this.allowedFiles.includes(a.name.split('.').pop())
        if (!result) {
          errFormat = a.name.split('.').pop()
        }
        return result
      })
      if (errFormat !== '') {
        this.errMsg(`${errFormat} file is not accepted.`)
      }
      this.formData.fileAttachments = r
      console.log(`File Length: ${this.formData.fileAttachments.length}`)
    },
    deleteFromFileBuffer (index) {
      let that = this
      this.$buefy.dialog.confirm({
        type: 'is-danger',
        title: 'Alert',
        hasIcon: true,
        message: 'Are you sure to delete the file ?',
        onConfirm: () => {
          that.formData.fileAttachments.splice(index, 1)
          console.log(`File Length: ${that.formData.fileAttachments.length}`)
        }
      })
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>

<style scoped>
#status {
  text-align: right;
}
.homework-description {
  border: solid rgb(223 179 196) 1px;
}
.left-auto {
  margin-left: 50%;
}
.relative {
  position: relative;
}
.close-icon {
  position: absolute;
  right: 0;
  top: 0;
}
.upload-title {
  font-weight: 600;
}
</style>
